export default process.env.NODE_ENV === 'production'
	? [
			{
				id: 'prod_NLbvfIn1yY9avn',
				link: 'https://buy.stripe.com/eVa29pfKE3bBb4sfYY',
				description: '100 shipments per month',
				title: 'Start',
				price: '9',
				period: 'month',
				numberOfTracks: 100,
				buttonColor: 'red',
				options: [
					{
						title: 'Access to 1540 carriers',
						description:
							'Receive status updates for any shipment, from postal postal and express carriers',
					},
					{
						title: 'Track air cargo by AWB',
						description:
							'Get detailed air cargo status updates from 100 airlines',
					},
					{
						title: 'Track road freight LTL, FTL',
						description:
							'Track road freight by PRO Number from major US and Canada freight carriers',
					},
					{
						title: 'Track sea freight by container or B/L',
						description:
							'Retrieve sea freight status updates from major carriers',
					},
					{
						title: 'Same day support by e-mail',
						description: 'You will get reply no later than 12 hours',
					},
				],
			},
			{
				id: 'prod_NLbwIQUQoGfPZG',
				link: 'https://buy.stripe.com/eVag0fdCw27xdcA4gh',
				description: '300 shipments per month',
				title: 'Pro',
				price: '19',
				period: 'month',
				numberOfTracks: 300,
				buttonColor: 'red',
				options: [
					{
						title: 'Access to 1540 carriers',
						description:
							'Receive status updates for any shipment, from postal postal and express carriers',
					},
					{
						title: 'Track air cargo by AWB',
						description:
							'Get detailed air cargo status updates from 100 airlines',
					},
					{
						title: 'Track road freight LTL, FTL',
						description:
							'Track road freight by PRO Number from major US and Canada freight carriers',
					},
					{
						title: 'Track sea freight by container or B/L',
						description:
							'Retrieve sea freight status updates from major carriers',
					},
					{
						title: 'Same day support by e-mail',
						description: 'You will get reply no later than 12 hours',
					},
				],
			},
			{
				id: 'prod_NLbwfB9PYE3wnK',
				link: 'https://buy.stripe.com/6oEaFV6a45jJgoM28a',
				description: '500 shipments per month',
				title: 'Premium',
				price: '29',
				period: 'month',
				numberOfTracks: 500,
				buttonColor: 'red',
				options: [
					{
						title: 'Access to 1540 carriers',
						description:
							'Receive status updates for any shipment, from postal postal and express carriers',
					},
					{
						title: 'Track air cargo by AWB',
						description:
							'Get detailed air cargo status updates from 100 airlines',
					},
					{
						title: 'Track road freight LTL, FTL',
						description:
							'Track road freight by PRO Number from major US and Canada freight carriers',
					},
					{
						title: 'Track sea freight by container or B/L',
						description:
							'Retrieve sea freight status updates from major carriers',
					},
					{
						title: 'Same day support by e-mail',
						description: 'You will get reply no later than 12 hours',
					},
				],
			},
			{
				id: 'prod_NLbxc6rX5yDmel',
				link: 'https://buy.stripe.com/aEU01haqkfYn1tSfZ1',
				description: '1000 shipments per month',
				title: 'Elite',
				price: '49',
				period: 'month',
				numberOfTracks: 1000,
				buttonColor: 'red',
				options: [
					{
						title: 'Access to 1540 carriers',
						description:
							'Receive status updates for any shipment, from postal postal and express carriers',
					},
					{
						title: 'Track air cargo by AWB',
						description:
							'Get detailed air cargo status updates from 100 airlines',
					},
					{
						title: 'Track road freight LTL, FTL',
						description:
							'Track road freight by PRO Number from major US and Canada freight carriers',
					},
					{
						title: 'Track sea freight by container or B/L',
						description:
							'Retrieve sea freight status updates from major carriers',
					},
					{
						title: 'Same day support by e-mail',
						description: 'You will get reply no later than 12 hours',
					},
				],
			},			
	  ]
	: [
			{
				id: 'prod_NDNCGuuaWZEKnW',
				link: 'https://buy.stripe.com/test_3cs00tbZOgCV8cE4gg',
				description: '100 shipments per month',
				title: 'Start',
				price: '9',
				period: 'month',
				numberOfTracks: 100,
				buttonColor: 'red',
				options: [
					{
						title: 'Access to 1540 carriers',
						description:
							'Receive status updates for any shipment, from postal postal and express carriers',
					},
					{
						title: 'Track air cargo by AWB',
						description:
							'Get detailed air cargo status updates from 100 airlines',
					},
					{
						title: 'Track road freight LTL, FTL',
						description:
							'Track road freight by PRO Number from major US and Canada freight carriers',
					},
					{
						title: 'Track sea freight by container or B/L',
						description:
							'Retrieve sea freight status updates from major carriers',
					},
					{
						title: 'Same day support by e-mail',
						description: 'You will get reply no later than 12 hours',
					},
				],
			},
			{
				id: 'prod_NKtXD006XTqF5h',
				link: 'https://buy.stripe.com/test_14k9B3fc00DX50sfYZ',
				description: '300 shipments per month',
				title: 'Pro',
				price: '19',
				period: 'month',
				numberOfTracks: 300,
				buttonColor: 'red',
				options: [
					{
						title: 'Access to 1540 carriers',
						description:
							'Receive status updates from any express, postal, LTL, FTL, air/sea cargo carrier around the world',
					},
					{
						title: 'Same day support by e-mail',
						description: 'You will get reply no later than 12 hours',
					},
				],
			},			
	  ];
